import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import { SypacButton, SypacText } from '@sypac/component-library-react';
import { T } from '@tolgee/react';
import TermsAndConditionsPartners from './TermsAndConditionsPartners';
import TermsAndConditionsCustomer from './TermsAndConditionsCustomer';
import Close from '../../assets/Close';

export interface TermsAndConditionsSecondStepProps {
	isOpen: boolean;
	finish?: () => void;
	target: string;
	termsAccepted?: boolean;
	onClose?: () => void;
}

const TermsAndConditionsSecondStep = (
	props: TermsAndConditionsSecondStepProps,
) => {
	const { isOpen, finish, target, termsAccepted = false, onClose } = props;
	const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);

	const listInnerRef = useRef<HTMLDivElement>(null);

	const onScroll = () => {
		if (listInnerRef.current) {
			const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
			const threshold = 10;
			const isNearBottom = scrollTop + clientHeight + threshold >= scrollHeight;

			if (isNearBottom) {
				// setIsVisible(true);
			}
		}
	};

	const handleClick = () => {
		setAcceptedTerms(!acceptedTerms);
		finish && finish();
	};

	return (
		<Modal
			isOpen={isOpen}
			className="modal-inside w-[95%] md:w-[70%] max-w-[700px] max-h-[85vh] outline-none overflow-hidden flex flex-col bg-white rounded-lg shadow-xl"
			overlayClassName="modal-overlay"
			shouldCloseOnOverlayClick={false}
			ariaHideApp={false}
		>
			<div className="flex items-center justify-between px-6 py-4 border-0 border-solid border-b-[1px] border-gray-10 flex-shrink-0">
				<SypacText variant="body-regular-medium">
					<p className="text-gray-90">
						<T keyName="termsAndConditions.termsAndConditions">
							Terms and Conditions
						</T>
					</p>
				</SypacText>
				{termsAccepted && (
					<SypacButton variant="subTitle">
						<button
							type="button"
							className="flex justify-center items-center h-[32px] w-[32px] p-0 bg-white border border-solid border-gray-10 transition hover:border-gray-60 rounded-lg"
							onClick={onClose}
						>
							<Close width="10" height="10" />
						</button>
					</SypacButton>
				)}
			</div>

			<div
				ref={listInnerRef}
				onScroll={onScroll}
				className="flex-1 overflow-y-auto px-6 py-6"
			>
				<div className="rounded-10 flex flex-col bg-gray-10-opacity-50 w-full mb-5">
					<div className="p-5">
						<SypacText variant="heading-4">
							<p className="text-gray-80">
								<T keyName="termsAndConditions.generalTermsOfUse">
									General terms of use and contractual conditions
								</T>
							</p>
						</SypacText>
						<SypacText variant="body-regular-medium" className="mt-3">
							<p className="text-gray-60">
								{['producer', 'transporter'].includes(target) ? (
									<T keyName="termsAndConditions.forPartnersIntending">
										For Partners intending to offer their goods and transport
										services.
									</T>
								) : (
									<T keyName="termsAndConditions.customersIntended">
										For Customers intended to use.
									</T>
								)}
							</p>
						</SypacText>
					</div>
				</div>

				<div className="mt-5">
					{['producer', 'transporter'].includes(target) ? (
						<TermsAndConditionsPartners />
					) : (
						<TermsAndConditionsCustomer />
					)}
				</div>
			</div>

			{!termsAccepted && (
				<div className="flex justify-end py-4 px-6 border-0 border-solid border-t-[1px] border-gray-10 flex-shrink-0 bg-white">
					<SypacButton variant="secondary" size="small" className="ml-auto">
						<button
							type="button"
							className="px-10 py-2.5 bg-primary-violet border-none text-white transition hover:bg-kimberly rounded-md cursor-pointer"
							onClick={handleClick}
						>
							<SypacText variant="body-regular-medium">
								<p className="text-white">
									<T keyName="termsAndConditions.finish">Yes, I Accept</T>
								</p>
							</SypacText>
						</button>
					</SypacButton>
				</div>
			)}
		</Modal>
	);
};

export default TermsAndConditionsSecondStep;
